import { updateDoc, collection, addDoc, doc, getDoc, getDocs } from "firebase/firestore";
import { getFunctions, httpsCallable } from 'firebase/functions'; 
import { db, auth } from '../utils/firebase.js';


export const _getGroupMembers = async (groupId) => {
    const groupMembers = { members: {}, owner: "", admins: []};
    const groupRef = doc(db, 'groups', groupId);
    const groupDoc = await getDoc(groupRef);
    const groupData = groupDoc.data();
    groupMembers.admins = groupData.groupAdmins;

    const groupMembersCollection = collection(db, "groups", groupId, "members");
    const querySnapshot = await getDocs(groupMembersCollection);
    querySnapshot.forEach((doc) => {
        var memberUid = doc.data().uid ?? -1;
        if (memberUid) {
            groupMembers.members[doc.id] = {
            displayName: doc.data().displayName,
            isOwner: groupData.owner === memberUid,
            isMe: auth.currentUser.uid === memberUid,
            isAdmin: groupMembers.admins.includes(memberUid),
            hasLogin: memberUid !== -1,
            inactive: doc.data().inactive,
            uid : memberUid
            };
        }
    });

    return groupMembers;
}

export const _removeMemberFromGroup = async(groupId, memberId) => {
    console.log(auth.currentUser);
    const functionsInstance = getFunctions();
    const removeMemberFromGroupCallable = httpsCallable(functionsInstance, 'removeMemberFromGroup');
    const result = await removeMemberFromGroupCallable({ memberId: memberId, groupId: groupId });
    return result;
}

export const _saveNewGroupMember = async (groupId, memberName) => {
    let newMember = {
        displayName: memberName
    }
    const groupMembersCollection = collection(db, "groups", groupId, "members");
    const docRef = await addDoc(groupMembersCollection, newMember);
    const memberId = docRef.id;
    newMember.memberId = memberId;
    return newMember;
}

export const _toggleAdmin = async(groupId, memberId, grantAdmin, groupAdmins) => {
    const [groupSnap, memberSnap] = await Promise.all([
        getDoc(doc(db, "groups", groupId)),
        getDoc(doc(db, "groups", groupId, "members", memberId))
    ]);
    
    const currentAdmins = groupSnap.data().groupAdmins || [];
    const memberUid = memberSnap.data().uid;
    
    if (!memberUid) {
        throw new Error("Member does not have a UID");
    }
    
    if (grantAdmin) {
        if (!currentAdmins.includes(memberUid)) {
            await updateDoc(doc(db, "groups", groupId), {
                groupAdmins: [...currentAdmins, memberUid]
            });
            groupAdmins.push(memberUid);
        }
    } else {
        if (currentAdmins.includes(memberUid)) {
            await updateDoc(doc(db, "groups", groupId), {
                groupAdmins: currentAdmins.filter(id => id !== memberUid)
            });
            const index = groupAdmins.indexOf(memberUid);
            if (index > -1) {
                groupAdmins.splice(index, 1);
            }
        }

    }

    return groupAdmins;
}

export const _updateMemberDisplayName = async(groupId, memberId, newName) => {
    const memberRef = doc(db, "groups", groupId, "members", memberId);
    const memberDoc = await getDoc(memberRef);

    if (memberDoc.exists()) {
        try {
            await updateDoc(memberRef, { displayName: newName });
        } catch (e) {
            console.log(e);
            return false;
        }

        return true;
    }

    return false;
}